import { toJS } from "mobx";

export const parametarExtractor = (props) => {
    let options = {};
    let params = [];
    let params1 = [];

    const { request_parameters, resource_store_properties_to_request } =
        props.schemaOptions.$mobx.values;
    params =
        request_parameters === undefined
            ? []
            : request_parameters.value.value.toJS().map((el) => {
                  return [el.name, el.value];
              });
    params1 =
        resource_store_properties_to_request === undefined
            ? []
            : resource_store_properties_to_request.value.value
                  .toJS()
                  .map((el) => {
                      return [el.name, el.value];
                  });

    params.forEach((el) => {
        options[el[0]] = el[1];
    });

    params1.forEach((el) => {
        let temp = props.data[el[1]];
        if (temp === undefined) return;
        if (temp && temp.id) {
            temp = temp.id;
        }
        temp = temp.$mobx ? temp.$mobx?.values : temp;
        if (Array.isArray(temp)) temp = temp.join(",");

        options[el[0]] = temp;
    });

    return options;
};
